import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { DashboardPage } from "./pages/dashboard/DashboardPage";
import { StoreListPage } from "./pages/store/StoreListPage";
import { StoreMapPage } from "./pages/store/StoreMapPage";
import { RevenueStatusPage } from "./pages/revenue/RevenueStatusPage";
import { TransactionListPage } from "./pages/revenue/TransactionListPage";
import { StatisticalAnalysisPage } from "./pages/revenue/StatisticalAnalysisPage";
import { CoinTransactionListPage } from "./pages/revenue/CoinTransactionListPage";
import { TicketListPage } from "./pages/ticket/TicketListPage";
import { MarketingListPage } from "./pages/marketing/MarketingListPage";
import { UserListPage } from "./pages/user/UserListPage";
import { SettingPage } from "./pages/setting/SettingPage";
import StoreDetailPage from "./pages/store/StoreDetailPage";
import LoginPage from "./pages/auth/LoginPage";
import TermsPage from "./pages/auth/TermsPage";
import RequestResetPasswordPage from "./pages/auth/RequestResetPasswordPage";
import ConfirmResetPasswordPage from "./pages/auth/ConfirmResetPasswordPage";
import TermDetailPage from "./pages/auth/TermDetailPage";
import JoinPage from "./pages/auth/JoinPage";
import AuthMessagePage from "./pages/auth/AuthMessagePage";
import InitPage from "./pages/auth/InitPage";
import VerifiedPage from "./pages/auth/VerifiedPage";
import LockLoginMessagePage from "./pages/auth/LockLoginMessagePage";
import UnlockLoginMessagePage from "./pages/auth/UnlockLoginMessagePage";
import FranchiseListPage from "./pages/franchise/FranchiseListPage";
import DebugRoleChangePage from "./pages/auth/DebugRoleChangePage";
import MoveAppPage from "./pages/auth/MoveAppPage";
import RoleChoicePage from "./pages/auth/RoleChoicePage";
import LoginRedirectPage from "./pages/auth/LoginRedirectPage";
import RoleMessagePage from "./pages/auth/RoleMessagePage";
import RequireAuth from "./common/components/auth/RequireAuth";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Router basename={process.env.REACT_APP_BASE_PATH || "/"}>
        <Routes>
            {/* 인증 + 권한별 메뉴 접근 제어. 허용되지 않은 경로는 렌더 전에 차단된다. */}
            <Route element={<RequireAuth />}>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/shops" element={<StoreListPage />} />
                <Route path="/franchises" element={<FranchiseListPage />} />
                <Route path="/shops/:id" element={<StoreDetailPage />} />
                <Route path="/shops/map" element={<StoreMapPage />} />
                <Route path="/revenues" element={<RevenueStatusPage />} />
                <Route path="/revenues/transactions" element={<TransactionListPage />} />
                <Route path="/revenues/statistical" element={<StatisticalAnalysisPage />} />
                <Route path="/revenues/coin-transactions" element={<CoinTransactionListPage />} />
                <Route path="/tickets" element={<TicketListPage />} />
                <Route path="/marketing" element={<MarketingListPage />} />
                <Route path="/users" element={<UserListPage />} />
                <Route path="/settings" element={<SettingPage />} />
            </Route>
            <Route path="/auth/init" element={<InitPage />} />
            <Route path="/auth" element={<InitPage />} />
            <Route path="/redirect" element={<LoginRedirectPage />} />
            <Route path="/auth/login" element={<LoginPage />} />
            <Route path="/auth/join" element={<JoinPage />} />
            <Route path="/auth/terms" element={<TermsPage />} />
            <Route path="/auth/terms/detail" element={<TermDetailPage />} />
            <Route path="/auth/message" element={<AuthMessagePage />} />
            <Route path="/auth/role-message" element={<RoleMessagePage />} />
            <Route path="/auth/verified" element={<VerifiedPage />} />
            <Route path="/auth/move-app" element={<MoveAppPage />} />
            <Route path="/auth/role-choice" element={<RoleChoicePage />} />
            <Route path="/auth/login-lock" element={<LockLoginMessagePage />} />
            <Route path="/auth/login-unlock" element={<UnlockLoginMessagePage />} />
            <Route path="/auth/reset-password/request" element={<RequestResetPasswordPage />} />
            <Route path="/auth/reset-password/confirm" element={<ConfirmResetPasswordPage />} />
            <Route path="/debug" element={<DebugRoleChangePage />} />
        </Routes>
    </Router>
);

reportWebVitals();
